window.addEventListener('turbo:load', () => {
  if (!location.href.includes('google_workspace')) {
    Sidebar.init();
  }
});

const Sidebar = (function () {
  const sidebarSelector = '.sidebar';
  const sidebarChevronSelector = '.sidebar-container .chevron';
  const contentContainerSelector = '.content-container';
  const backButtonSelector = '.fa-angle-double-left';

  let sidebar;
  let sidebarChevron;
  let contentContainer;
  let backButton;
  let dropdowns = {};

  function initialize() {
    sidebar = document.querySelector(sidebarSelector);
    sidebarChevron = document.querySelector(sidebarChevronSelector);
    contentContainer = document.querySelector(contentContainerSelector);
    backButton = document.querySelector(backButtonSelector);

    sidebarChevron.addEventListener('click', toggleSidebar);
    if (isSidebarExpanded() === 'no') {
      savedShrunkSidebar();
    }

    document.querySelectorAll('.sidebar li[data-dropdown]').forEach(function (el) {
      const dropdown = document.querySelector(el.dataset.dropdown);
      dropdowns[el.dataset.dropdown] = dropdown;
      el.addEventListener('click', toggleDropdown);
    });
  }

  function toggleSidebar() {
    if (isSidebarExpanded() === 'yes') {
      shrinkSidebar();
    } else {
      expandSidebar();
    }
  }

  function toggleDropdown(event) {
    const dropdown = dropdowns[event.target.dataset.dropdown];
    Object.values(dropdowns).forEach(function (dd) {
      if (dd != dropdown) {
        dd.classList.remove('active');
      }
    });
    dropdown.classList.toggle('active');
  }

  function expandSidebar() {
    sidebar.classList.remove('inactive');
    sidebar.classList.remove('saved-inactive');
    contentContainer.classList.remove('active');
    contentContainer.classList.remove('saved-active');

    if (backButton) {
      backButton.classList.remove('move-left');
      backButton.classList.remove('saved-left');
      backButton.classList.add('move-right');
    }
    localStorage.setItem('isSidebarExpanded', 'yes');
  }

  function shrinkSidebar() {
    sidebar.classList.add('inactive');
    contentContainer.classList.add('active');
    if (backButton) {
      backButton.classList.remove('move-right');
      backButton.classList.add('move-left');
    }
    localStorage.setItem('isSidebarExpanded', 'no');
  }

  function savedShrunkSidebar() {
    sidebar.classList.add('saved-inactive');
    contentContainer.classList.add('saved-active');
    if (backButton) {
      backButton.classList.add('saved-left');
    }
  }

  function isSidebarExpanded() {
    return localStorage.getItem('isSidebarExpanded') || 'yes';
  }

  return {
    init: initialize,
  };
})();
